'use strict';

// Constructor
var Wysiwyg = function(config) {
  var self = this;

  self.parseEmbeds = function() {
    var $embed = $(config.wysiwyg).find('iframe');
    $embed.each(function() {
      var $this = $(this);
      self.wrapEmbeds($this);
    });
  }

  self.wrapEmbeds = function($embed) {
    $embed.wrap(config.responsiveEmbedEl);
  }

  self.init = function() {
    self.parseEmbeds();
  }
};

module.exports = Wysiwyg;
